<p-contextmenu #cm [model]="_contextMenu" appendTo="body" />

<p-treetable
    #ptree
    stripedRows
    [rowTrackBy]="TreeUtils.treeNodeTrackByKey"
    [dataKey]="dataKey"
    [columns]="selectedColumns"
    [value]="data"
    [loading]="showTreeLoading"
    [globalFilterFields]="searcheableFields"
    [resizableColumns]="true"
    [autoLayout]="true"
    [scrollable]="true"
    [scrollHeight]="flexHeight == true ? 'flex' : undefined"
    styleClass="p-treetable-striped p-treetable-gridlines p-treetable-sm"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [reorderableColumns]="true"
    [selectionMode]="selectionMode"
    (selectionChange)="selectionChange($event)"
    [(selection)]="selection"
    (onContextMenuSelect)="contextMenuSelect($event)"
    [contextMenu]="_contextMenu ? cm : undefined"
>
    <ng-template pTemplate="caption" *ngIf="showTopBar || showColumnToggle || showAutoRefresh">
        <div class="header-flex">
            <div style="display: flex; gap: 0.5rem">
                @if (showSearch && searcheableFields.length > 0) {
                    <div style="width: 20rem; display: inline-block">
                        <p-iconfield>
                            <p-inputicon class="pi pi-search" />
                            <input
                                [id]="_treeID + 'SearchBar'"
                                pInputText
                                type="text"
                                [value]="_searchValue ?? ''"
                                (input)="ptree.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="Search words"
                            />
                        </p-iconfield>
                    </div>
                }
                @if (showColumnToggle) {
                    <div style="width: 15rem; display: inline-block">
                        <p-multiSelect
                            [options]="_dataCols"
                            [(ngModel)]="selectedColumns"
                            optionLabel="header"
                            selectedItemsLabel="{0} columns selected"
                            [style]="{'text-transform': 'capitalize'}"
                            placeholder="Choose Columns"
                            [ngModelOptions]="{standalone: true}"
                        ></p-multiSelect>
                    </div>
                }
                @if (showAutoRefresh) {
                    <app-auto-refresh
                        [defaultInterval]="autoRefreshDefaultInterval"
                        [disabled]="showTreeLoading"
                        (refresh)="refreshEvent.emit()"
                    ></app-auto-refresh>
                }
            </div>

            <div class="caption-controls">
                @if (showRefreshButton || showHelpButton || showNewButton) {
                    <div class="caption-buttons">
                        @if (showRefreshButton) {
                            <p-button severity="secondary" icon="pi pi-refresh" (click)="refreshEvent.emit()" />
                        }
                        @if (showHelpButton) {
                            <p-button severity="secondary" icon="pi pi-question" (click)="helpEvent.emit()" />
                        }
                        @if (showNewButton) {
                            <p-button
                                severity="primary"
                                (click)="newEvent.emit()"
                                [label]="newButtonCaption || 'New ' + entityName"
                            />
                        }
                    </div>
                }
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="loadingicon">
        <p-progress-spinner styleClass="w-4rem h-4rem" strokeWidth="4" animationDuration="1.5s"></p-progress-spinner>
        <div class="mt-2 mb-2" [ngStyle]="{color: 'white', fontSize: '1.5rem', fontWeight: 'bold'}">
            {{ treeLoadingStr }}
        </div>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="50">
                @if (data.length === 0 && !showTreeError) {
                    <p-message severity="warn">There is nothing to show.</p-message>
                }
                @if (showTreeError) {
                    <p-message severity="warn">An error occured while getting datas.</p-message>
                }
            </td>
        </tr>
    </ng-template>

    <ng-template #colgroup let-columns>
        <colgroup>
            <col *ngFor="let col of columns" />
        </colgroup>
    </ng-template>

    <ng-template pTemplate="header" let-columns>
        <tr>
            @for (rawCol of columns; track rawCol.__iID!) {
                @let colCache = _colsCache[rawCol.__iID!];
                @let col = colCache.treeColDef!;

                @if (col.sortable) {
                    <th
                        [ttSortableColumn]="col.field"
                        ttResizableColumn
                        ttReorderableColumn
                        [ngStyle]="{width: col.colWidth}"
                    >
                        {{ col.header | titlecase }}
                        <p-treetable-sort-icon [field]="col.field"></p-treetable-sort-icon>
                    </th>
                } @else {
                    @if (!col.sortable) {
                        <th ttResizableColumn ttReorderableColumn [ngStyle]="{width: col.colWidth}">
                            {{ col.header | titlecase }}
                        </th>
                    }
                }
            }

            @if (_buttonCols.length > 0 || _contextMenu) {
                <th [ngStyle]="{width: _buttonsColWidth}"></th>
            }
        </tr>

        @if (filterableFields.length > 0 && !showTreeLoading) {
            <!-- TODO implement filters-->
        }
    </ng-template>

    <ng-template #body let-rowNode let-rowData="rowData" let-columns="columns">
        @if (!showTreeLoading) {
            <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode" [ttContextMenuRow]="rowNode">
                @for (rawCol of columns; track rawCol.__iID!) {
                    @let colCache = _colsCache[rawCol.__iID!];
                    @let col = colCache.treeColDef!;
                    @let colI = columns.indexOf(rawCol);

                    @if (col.type === ETreeColType.DATA) {
                        <td
                            [pTooltip]="col.tooltipField ? get(rowData, col.tooltipField) : (col.tooltip ?? '')"
                            [ngStyle]="col?.tdStyle"
                            [ngStyle]="{width: col.colWidth}"
                        >
                            <div
                                (click)="
                                    col.dataType != ETreeColDataType.LINK ? col.fnOnCellClick?.(rowData) : undefined
                                "
                                [class]="colCache.wrapperClassList"
                                [ngStyle]="rowNode.node.style"
                            >
                                @if (colI == 0) {
                                    <p-treetable-toggler [rowNode]="rowNode" />
                                }
                                @if (rowNode.node.icon && col.nodeIconSide === 'left') {
                                    <span [ngClass]="rowNode.node.icon" [ngStyle]="rowNode.node.iconStyle"></span>
                                }
                                @if (col.fnCustomData) {
                                    <div
                                        [class]="col.fnCellWrappingClassName?.(rowData) ?? ''"
                                        *ngTemplateOutlet="
                                            cellDataTemplate;
                                            context: {
                                                rowNode: rowNode,
                                                colID: col.__iID,
                                                colI: colI,
                                                row: rowData,
                                                colValue: col.fnCustomData(rowData)
                                            }
                                        "
                                    ></div>
                                } @else {
                                    <div
                                        [class]="col.fnCellWrappingClassName?.(rowData) ?? ''"
                                        *ngTemplateOutlet="
                                            cellDataTemplate;
                                            context: {
                                                rowNode: rowNode,
                                                colID: col.__iID,
                                                colI: colI,
                                                row: rowData,
                                                colValue: get(rowData, col.field)
                                            }
                                        "
                                    ></div>
                                }

                                @if (rowNode.node.icon && col.nodeIconSide === 'right') {
                                    <span [ngClass]="rowNode.node.icon" [ngStyle]="rowNode.node.iconStyle"></span>
                                }
                            </div>
                        </td>
                    }
                }

                @if (_buttonCols.length > 0 || _contextMenu) {
                    <td [ngStyle]="{width: _buttonsColWidth}">
                        <div class="btn-flex">
                            @for (col of cols; track col.__iID) {
                                @if (col.type === ETreeColType.BUTTON) {
                                    <p-button
                                        [pTooltip]="col.tooltip || ''"
                                        [icon]="col.icon ?? ''"
                                        [severity]="col.buttonSeverity ?? 'primary'"
                                        (click)="col.fnOnButtonClick?.(rowData)"
                                        size="small"
                                    />
                                }
                            }
                            @if (_contextMenu) {
                                <p-button
                                    severity="secondary"
                                    (click)="contextMenuSelect(rowNode); cm.show($event)"
                                    icon="pi pi-ellipsis-h"
                                    size="small"
                                />
                            }
                        </div>
                    </td>
                }
            </tr>
        } @else {
            @for (idx of [0]; track idx) {
                <tr>
                    @for (col of selectedColumns; track col.__iID) {
                        <td>
                            <p-skeleton></p-skeleton>
                        </td>
                    }
                    @if (_buttonCols.length > 0 || _contextMenu) {
                        <td>
                            <p-skeleton></p-skeleton>
                        </td>
                    }
                </tr>
            }
        }
    </ng-template>
</p-treetable>

<ng-template
    #cellDataTemplate
    let-rowNode="rowNode"
    let-colID="colID"
    let-colI="colI"
    let-row="row"
    let-colValue="colValue"
    let-firstCell="firstCell"
>
    @let colCache = _colsCache[colID!]!;
    @let col = colCache.treeColDef!;
    @let cellValueAsBool = colValue !== null && colValue !== undefined ? !!colValue : false;

    @if (col.fnCustomPrefixIcon) {
        <span [classList]="col.fnCustomPrefixIcon(row)"></span>
    }

    @switch (col.dataType) {
        @case (ETreeColDataType.LONG_TEXT) {
            <div>
                {{ colValue?.length > 100 ? (colValue | slice: 0 : 50) + '...' : colValue }}
            </div>
        }
        @case (ETreeColDataType.IMAGE) {
            <div style="text-align: center">
                <div class="img-maintain-ratio">
                    <img [src]="colValue ?? '/assets/images/image_not_found.png'" alt="Image" />
                </div>
            </div>
        }
        @case (ETreeColDataType.DATE) {
            {{ colValue | date: col.customDateFormat || SDKConfig.dateFormat }}
        }
        @case (ETreeColDataType.BOOLEAN_LABEL) {
            @if (cellValueAsBool) {
                <p-tag value="Yes" [rounded]="false" [style]="colCache.booleanLabelStyleCache?.[0]"></p-tag>
            } @else {
                <p-tag value="No" [rounded]="false" [style]="colCache.booleanLabelStyleCache?.[1]"></p-tag>
            }
        }
        @case (ETreeColDataType.BOOLEAN_ICON) {
            <i [class]="cellValueAsBool ? 'pi pi-check green' : ''"></i>
        }
        @case (ETreeColDataType.BOOLEAN_ICON_INV) {
            <i [class]="cellValueAsBool ? '' : 'pi pi-check green'"></i>
        }
        @case (ETreeColDataType.CHECKBOX) {
            <p-checkbox [value]="colValue" [readonly]="true"></p-checkbox>
        }
        @case (ETreeColDataType.CONDITIONAL_CHECKBOX) {
            @if (colValue !== null && colValue !== undefined) {
                <p-checkbox [ngModel]="colValue" [binary]="true" [disabled]="colValue"></p-checkbox>
            }
        }
        @case (ETreeColDataType.TAGS) {
            @for (tagOpts of col.tags || []; track tagOpts) {
                @if (tagOpts.value === null || tagOpts.value === undefined || tagOpts.value === colValue) {
                    @if (tagOpts.icon && tagOpts.iconStyle) {
                        <p-tag
                            [pTooltip]="tagOpts.tooltip"
                            [value]="tagOpts.label || colValue"
                            [rounded]="false"
                            [style]="tagOpts.style!"
                            [styleClass]="tagOpts.styleClass"
                        >
                            <i [class]="tagOpts.icon" [ngStyle]="tagOpts.iconStyle"></i>
                        </p-tag>
                    } @else {
                        <p-tag
                            [icon]="tagOpts.icon"
                            [pTooltip]="tagOpts.tooltip"
                            [value]="tagOpts.label || colValue"
                            [rounded]="false"
                            [style]="tagOpts.style!"
                            [styleClass]="tagOpts.styleClass"
                        ></p-tag>
                    }
                }
            }
        }
        @case (ETreeColDataType.CHIPS) {
            @for (chip of colValue || []; track chip) {
                <p-chip [label]="chip" />
            }
        }
        @case (ETreeColDataType.STATUS_TAG) {
            <app-status-tag
                [status]="colValue"
                [displayMode]="col.statusTagDisplayMode || EStatusTagDisplayMode.ICON"
                [isLocked]="col.statusTagLockEvalColumn ? row[col.statusTagLockEvalColumn] : false"
            ></app-status-tag>
        }
        @case (ETreeColDataType.LINK) {
            <a (click)="col.fnOnCellClick?.(row)">{{ colValue }}</a>
        }
        @case (ETreeColDataType.DATA_DISPLAY_CELL_COMPONENT) {
            @if (col.dataCellDisplayComponent) {
                <ng-template
                    *ngComponentOutlet="
                        col.dataCellDisplayComponent;
                        inputs: {
                            displayType: 'tree',
                            extra: col.dataCellDisplayExtra,
                            rows: data,
                            row: rowNode.node,
                            attribute: col.field,
                            value: col.fnCustomData?.(row) ?? colValue
                        }
                    "
                ></ng-template>
            } @else {
                <i>No component...</i>
            }
        }
        @default {
            {{ colValue }}
        }
    }
</ng-template>
